import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/service/alert.service';
import { PersquisaService } from 'src/app/service/persquisa.service';
import { DialogEscolherGrupoComponent } from '../dialog-escolher-grupo/dialog-escolher-grupo.component';
import { ProdutosService } from './../../service/produtos.service';

@Component({
  selector: 'app-pesquisa-cadastrar',
  templateUrl: './pesquisa-cadastrar.component.html',
  styleUrls: ['./pesquisa-cadastrar.component.css']
})
export class PesquisaCadastrarComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private produtoService: ProdutosService,
    public dialog: MatDialog,
    private pesquisaService: PersquisaService,
    private alertService: AlertService,
    private router: Router, 
  ) { }

  form!: FormGroup;
  produtos: any;
  inputs = [] as any

  ngOnInit(): void {
    this.formulario();
    this.acharProduto();
  }

  acharProduto() {
    this.produtoService.listarService().subscribe(produtos => {
      this.produtos = produtos;
    })
  }

  formulario() {
    this.form = this.formBuilder.group({
      vc_descricao: new FormControl('', [Validators.required]),
      vc_titulo: new FormControl('', [Validators.required]),
      vc_subtitulo: new FormControl('', [Validators.required]),
      fk_produto: new FormControl('', [Validators.required]),
      it_verificacao: new FormControl('', [Validators.required]),
      vc_observacao: new FormControl('', [Validators.required]),
      vc_frase_observacao: new FormControl('Observação', [Validators.required]),
      ar_perguntas: this.formBuilder.array([
        this.formBuilder.group({
          vc_pergunta: new FormControl('', [Validators.required]),
          fk_grupo_resposta: new FormControl('', [Validators.required])
        })
      ])
    })
    var control = <FormArray>this.form.get('ar_perguntas');
    this.inputs = control['controls']
  }

  adicionarPergunta(){
    var control = <FormArray>this.form.get('ar_perguntas');
    control.push(this.formBuilder.group({
      vc_pergunta: new FormControl('', [Validators.required]),
      fk_grupo_resposta: new FormControl('', [Validators.required])
    }))
    this.inputs = control['controls']
  }

  selecionarGrupo(form:any){
    const dialogRef = this.dialog.open(DialogEscolherGrupoComponent, {
      width: '30vw'
    });
    dialogRef.afterClosed().subscribe(result => {
      this.form.get('ar_perguntas')!.value[form].fk_grupo_resposta = result;
    });
  }

  cadastrar() {
    this.pesquisaService.criarPesquisa(this.form.value).subscribe(resp => {
      this.alertService.success();
      this.router.navigate(['configuracao/contratos']);
    }, error => {
      this.alertService.error(error);
    })
  }

  
}
